var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c("google-analytics"),
      _c("div", { staticClass: "pkb-nav" }, [
        _vm._m(0),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              gap: "10px",
              "align-items": "center",
            },
          },
          [
            _c("div", { staticClass: "menu-wrapper" }, [
              _vm._m(1),
              _c(
                "div",
                { staticClass: "menu" },
                [
                  _c(
                    "div",
                    { staticClass: "main-menu-items" },
                    _vm._l(_vm.pkbMenu.highlightItems, function (item) {
                      return _c(
                        "div",
                        {
                          staticClass: "menu-item-wrapper",
                          class: { active: _vm.isActive(item.path) },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "menu-item menu-item-main",
                              attrs: { href: item.path },
                            },
                            [_vm._v(_vm._s(item.label))]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._l(_vm.pkbMenu.menuItems, function (item) {
                    return _c(
                      "div",
                      {
                        staticClass: "menu-item-wrapper",
                        class: { active: _vm.isActive(item.path) },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "menu-item",
                            attrs: { href: item.path || null },
                          },
                          [_vm._v(_vm._s(item.label))]
                        ),
                        item.subMenuItems
                          ? _c(
                              "div",
                              { staticClass: "submenu" },
                              _vm._l(item.subMenuItems, function (subItem) {
                                return _c(
                                  "a",
                                  {
                                    staticClass: "submenu-item",
                                    class: {
                                      active: _vm.isActive(subItem.path),
                                    },
                                    attrs: {
                                      href: subItem.path || null,
                                      "data-whatever": _vm
                                        .isActive(subItem.path)
                                        .toString(),
                                    },
                                  },
                                  [_vm._v(_vm._s(subItem.label))]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
            _vm._m(2),
          ]
        ),
        _c("div", { staticClass: "pkb-beta" }, [_vm._v("beta")]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "logo" }, [
      _c("a", { attrs: { href: "/" } }, [
        _c("img", {
          staticStyle: { height: "50px" },
          attrs: {
            src: "https://hugeampkpncms.org/sites/default/files/users/user32/pankbase/PanKbase_logo-black-tagline.svg",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "topmenu" }, [
      _c("a", { staticClass: "topmenu-item" }, [
        _vm._v(" Search "),
        _c("img", {
          staticStyle: { height: "15px", width: "15px" },
          attrs: {
            src: "https://hugeampkpncms.org/sites/default/files/users/user32/pankbase/search-icon.svg",
          },
        }),
      ]),
      _c("a", { staticClass: "topmenu-item" }, [_vm._v(" Analysis ")]),
      _c("a", { staticClass: "topmenu-item" }, [
        _vm._v(" Login "),
        _c("img", {
          staticStyle: { height: "15px", width: "15px" },
          attrs: {
            src: "https://hugeampkpncms.org/sites/default/files/users/user32/pankbase/user-icon.svg",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      { attrs: { href: "https://hirnetwork.org/", target: "_blank" } },
      [
        _c("img", {
          staticStyle: { height: "37px" },
          attrs: {
            src: "https://hugeampkpncms.org/sites/default/files/images/pankbase/logo-hirn.svg",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }